module.exports = __webpack_public_path__ + "img/ic_main_menu_setting_active.1fbecd51.png";